import React from 'react';
import { Subhead, Body2 } from '@xo-union/tk-ui-typography';
import styles from './eipSection.scss';
import kebabCase from 'lodash/kebabCase';

interface Props {
  title?: string;
  description?: React.ReactNode;
  children?: React.ReactNode;
}

export const EIPSection: React.FC<Props> = ({ title, description, children }) => {
  const kebabTitle = title ? kebabCase(title) : '';
  return (
    <div data-testid={`eip-section-${kebabTitle}`} className={styles.section}>
      <div className={styles.title}>
        <Subhead>
          <strong>{title}</strong>
        </Subhead>
      </div>
      <Body2>{description}</Body2>
      <>{children}</>
    </div>
  );
};
